import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import { SoldToAddress } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import { Website } from "@insite/client-framework/Services/WebsiteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { NARegion } from "@dana/Common/Constants";

const enum fields {
    formUrl = "formUrl",
    orgId = "orgId",
    returnUrl = "returnUrl",
    customerNameId = "customerNameId",
    customerNumberId = "customerNumberId",
    topicId = "topicId",
    danaPartNumberId = "danaPartNumberId",
    customerPartNumberId = "customerPartNumberId",
    poNumberId = "poNumberId",
    alternateEmailId = "alternateEmailId",
    plantCodeId = "plantCodeId",
    caseDescriptionId = "caseDescriptionId",
    nameId = "nameId",
    emailId = "emailId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.formUrl]: string;
        [fields.nameId]: string;
        [fields.orgId]: string;
        [fields.returnUrl]: string;
        [fields.customerNameId]: string;
        [fields.customerNumberId]: string;
        [fields.topicId]: string;
        [fields.danaPartNumberId]: string;
        [fields.customerPartNumberId]: string;
        [fields.poNumberId]: string;
        [fields.alternateEmailId]: string;
        [fields.plantCodeId]: string;
        [fields.caseDescriptionId]: string;
        [fields.emailId]: string;
    };

    websiteData?: Website;
}

export interface CutomerrOperationsCaseStyles {
    headingText?: TypographyPresentationProps;
    formContainer?: InjectableCss;
    textField?: TextFieldPresentationProps;
    formGroup?: InjectableCss;
    label?: InjectableCss;
    inputText?: TextFieldPresentationProps;
    dropdown?: SelectPresentationProps;
    textArea?: TextAreaPresentationProps;
    submitButton?: ButtonPresentationProps;
    backButton?: ButtonPresentationProps;
    button?: ButtonPresentationProps;
    formGroupButton?: InjectableCss;
}

export const styles: CutomerrOperationsCaseStyles = {
    formContainer: {
        css: css`
            max-width: 700px;
            background: ${themeBackgrounds.white};
            margin: 0 auto;

            .form-section {
                padding: 20px;
            }

            .company-logo {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 70px;
                            height: 49px;
                        `,
                        css`
                            width: 70px;
                            height: 49px;
                        `,
                        css`
                            margin-left: 20px;
                            width: 105px;
                            height: 74px;
                        `,
                        css`
                            margin-left: 20px;
                            width: 105px;
                            height: 74px;
                        `,
                        css`
                            margin-left: 20px;
                            width: 105px;
                            height: 74px;
                        `,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        .case-form-header {
                            display: flex;
                            align-items: center;
                            background: ${themeColors.primary.danaBlue};
                            flex-direction: column;
                            gap: 10px;
                            padding: 20px;
                        }
                    `,
                    css`
                        .case-form-header {
                            display: flex;
                            align-items: center;
                            background: ${themeColors.primary.danaBlue};
                            flex-direction: column;
                            gap: 10px;
                            padding: 20px;
                        }
                    `,
                    css`
                        .case-form-header {
                            display: flex;
                            align-items: center;
                            background: ${themeColors.primary.danaBlue};
                            padding: 20px;
                            gap: 80px;
                        }
                    `,
                    css`
                        .case-form-header {
                            display: flex;
                            align-items: center;
                            background: ${themeColors.primary.danaBlue};
                            padding: 20px;
                            gap: 80px;
                        }
                    `,
                    css`
                        .case-form-header {
                            display: flex;
                            align-items: center;
                            background: ${themeColors.primary.danaBlue};
                            padding: 20px;
                            gap: 80px;
                        }
                    `,
                ])}
        `,
    },
    headingText: {
        variant: "h1",
        color: themeBackgrounds.white,
        css: css`
            text-align: left;
            margin-bottom: 0px;
            flex: 2;
        `,
    },
    formGroup: {
        css: css`
            .text-danger {
                color: ${themeColors.danger};
                padding-left: 5px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        flex-wrap: wrap;
                        flex-direction: row;
                        padding: 5px;
                        > div {
                            flex: 1 1 auto;
                            margin: 5px;
                        }
                    `,
                    css`
                        display: flex;
                        flex-wrap: wrap;
                        flex-direction: row;
                        padding: 5px;
                        > div {
                            flex: 1 1 auto;
                            margin: 5px;
                        }
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        gap: 20px;

                        label {
                            flex: 1;
                            display: flex;
                            justify-content: end;
                        }

                        > div {
                            flex: 2;
                            margin: 5px;
                        }
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        gap: 20px;

                        label {
                            flex: 1;
                            display: flex;
                            justify-content: end;
                        }

                        > div {
                            flex: 2;
                            margin: 5px;
                        }
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        gap: 20px;

                        label {
                            flex: 1;
                            display: flex;
                            justify-content: end;
                        }

                        > div {
                            flex: 2;
                            margin: 5px;
                        }
                    `,
                ])}
        `,
    },
    label: {
        css: css`
            flex: 1;
        `,
    },
    inputText: {
        cssOverrides: {
            formField: css`
                flex: 2;
            `,
            formInputWrapper: css`
                flex: 2;
            `,
        },
        css: css`
            flex: 2;
            padding: 5px;
        `,
    },
    dropdown: {
        css: css`
            flex: 2;
            padding: 5px;
        `,
    },
    textArea: {
        css: css`
            flex: 2;
            padding: 5px;
        `,
    },
    formGroupButton: {
        css: css`
            display: flex;
            justify-content: end;
            gap: 8px;
        `,
    },
    submitButton: {
        variant: "primary",
    },
    backButton: {
        variant: "secondary",
    },
};

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const session = getSession(state);
    const danaGeneralSettings = getDanaGeneralSettings(state);
    return {
        ...ownProps,
        session,
        danaGeneralSettings,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export const CustomerOpereationsCase: FC<Props> = ({ session, websiteData, danaGeneralSettings, fields }) => {
    const soldToObj: SoldToAddress | undefined = session?.properties?.soldToAddress
        ? JSON.parse(session.properties.soldToAddress)
        : undefined;
    const url = IS_SERVER_SIDE ? getUrl()! : window.location;
    const formSubmitted = url.href.includes("?submit=success");

    useEffect(() => {
        const region = session?.language?.properties?.region;
        if (!session.isAuthenticated || session.isGuest || session?.properties?.userType === "EFRQ" ||  region !== NARegion) {
            window.location.href = "/";
        }
    }, []);

    return formSubmitted ? (
        <>
            <StyledWrapper {...styles.formContainer}>
                <header className="case-form-header">
                    <img
                        src={danaGeneralSettings?.emailLogo || "/UserFiles/Images/Danaaftermarket.png"}
                        alt="Company Logo"
                        className="company-logo"
                    />
                    <Typography tabIndex={0} {...styles.headingText}>
                        {translate("How Can We Help?")}
                    </Typography>
                </header>
                <Typography tabIndex={0} variant={"h2"}>
                    {translate("Thank You for Your Business")}
                </Typography>
                <Typography tabIndex={0} variant={"h4"}>
                    {translate("A confirmation containing a customer service case  number will be emailed shortly.")}
                </Typography>
            </StyledWrapper>
        </>
    ) : (
        <>
            <StyledWrapper {...styles.formContainer}>
                <header className="case-form-header">
                    <img
                        src={danaGeneralSettings?.emailLogo || "/UserFiles/Images/Danaaftermarket.png"}
                        alt="Company Logo"
                        className="company-logo"
                    />
                    <Typography tabIndex={0} {...styles.headingText}>
                        {translate("How Can We Help?")}
                    </Typography>
                </header>
                <form action={fields.formUrl + fields.orgId} method="POST" className="form-section">
                    <input type="hidden" name="orgid" value={fields.orgId} />
                    <input type="hidden" name="retURL" value={fields.returnUrl} />
                    <input type="hidden" name="Plant_Code__c" value={session.properties.plantCode} />
                    <input type="hidden" name="recordType" id="recordType" value="012i0000000BSrgAAG" />

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="name">
                            {translate("Name")}
                        </label>
                        <TextField
                            type="text"
                            id={fields.nameId}
                            name={fields.nameId}
                            value={session?.isAuthenticated ? `${session?.firstName} ${session?.lastName}` : ""}
                            {...styles.textField}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="email">
                            {translate("Email")}
                        </label>
                        <TextField
                            type="email"
                            id={fields.emailId}
                            name={fields.emailId}
                            value={session?.isAuthenticated ? `${session?.email}` : ""}
                            {...styles.textField}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="customer-name">
                            {translate("Customer Name")}
                        </label>
                        <TextField
                            type="text"
                            id={fields.customerNameId}
                            name={fields.customerNameId}
                            value={soldToObj?.CompanyName ?? ""}
                            {...styles.textField}
                            title="customer name"
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="customer-number">
                            {translate("Customer Number")}
                        </label>
                        <TextField
                            type="text"
                            id={fields.customerNumberId}
                            name={fields.customerNumberId}
                            value={soldToObj?.CustomerSequence ?? ""}
                            {...styles.textField}
                            title="customer number"
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="topic">
                            {translate("Topic")}
                            <Typography className="text-danger text-body-sm">*</Typography>
                        </label>
                        <Select
                            id={fields.topicId}
                            name={fields.topicId}
                            {...styles.dropdown}
                            title="Topic"
                            required={true}
                        >
                            <option value="">{translate("--Select--")}</option>
                            <option value="Annual Return">{translate("Annual Return")}</option>
                            <option value="Cancel Existing Order">{translate("Cancel Existing Order")}</option>
                            <option value="Core Return">{translate("Core Return")}</option>
                            <option value="Customer Account Changes">{translate("Customer Account Changes")}</option>
                            <option value="Existing Order Change">{translate("Existing Order Change")}</option>
                            <option value="Invoice/Pricing Issue">{translate("Invoice/Pricing Issue")}</option>
                            <option value="Lost/Damaged/Missing Documentation – Freight Issue">
                                {translate("Lost/Damaged/Missing Documentation – Freight Issue")}
                            </option>
                            <option value="Part Return Request">{translate("Part Return Request")}</option>
                            <option value="Place Emergency Order">{translate("Place Emergency Order")}</option>
                            <option value="Place Stock Order">{translate("Place Stock Order")}</option>
                            <option value="PO/Part Status Update">{translate("PO/Part Status Update")}</option>
                            <option value="Price">{translate("Price")}</option>
                            <option value="Availability">{translate("Availability")}</option>
                            <option value="Quality Issue">{translate("Quality Issue")}</option>
                            <option value="Request for Credit">{translate("Request for Credit")}</option>
                            <option value="Shortage/Overage on Shipment">
                                {translate("Shortage/Overage on Shipment")}
                            </option>
                            <option value="Technical Support">{translate("Technical Support")}</option>
                        </Select>
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="dana-part-number">
                            {translate("Dana Part Number")}
                            <Typography className="text-danger text-body-sm">*</Typography>
                        </label>
                        <TextField
                            type="text"
                            id={fields.danaPartNumberId}
                            name={fields.danaPartNumberId}
                            title="dana part number"
                            required={true}
                            {...styles.textField}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="customer-part-number">
                            {translate("Customer Part Number")}
                        </label>
                        <TextField
                            type="text"
                            id={fields.customerPartNumberId}
                            name={fields.customerPartNumberId}
                            title="customer part number"
                            {...styles.textField}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="po-number">
                            {translate("PO Number / RFQ")}
                            <Typography className="text-danger text-body-sm">*</Typography>
                        </label>
                        <TextField
                            type="text"
                            id={fields.poNumberId}
                            name={fields.poNumberId}
                            title="p o number/ rfq"
                            {...styles.textField}
                            required={true}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="alternate-email">
                            {translate("Alternate Email")}
                        </label>
                        <TextField
                            type="text"
                            id={fields.alternateEmailId}
                            name={fields.alternateEmailId}
                            {...styles.textField}
                        />
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <label {...styles.label} htmlFor="details-comments">
                            {translate("Details / Comments")}
                            <Typography className="text-danger text-body-sm">*</Typography>
                        </label>
                        <TextArea
                            id={fields.caseDescriptionId}
                            name={fields.caseDescriptionId}
                            title="details / comments"
                            required={true}
                            {...styles.textArea}
                        ></TextArea>
                    </StyledWrapper>

                    <StyledWrapper {...styles.formGroup}>
                        <input type="hidden" id="external" name="external" value="1" />
                        <br />
                        <StyledWrapper {...styles.formGroupButton}>
                            <Button {...styles.submitButton} type="submit" name="submit">
                                {translate("Submit")}
                            </Button>
                        </StyledWrapper>
                    </StyledWrapper>
                </form>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CustomerOpereationsCase),
    definition: {
        group: "Common",
        displayName: "Customer Opereations Case Widget",
        fieldDefinitions: [
            {
                name: fields.formUrl,
                editorTemplate: "TextField",
                displayName: "Form Url",
                defaultValue:
                    "https://dana--uat.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8&orgId=",
                fieldType: "General",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.nameId,
                editorTemplate: "TextField",
                displayName: "Name Id",
                defaultValue: "Name__c",
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
            },
            {
                name: fields.emailId,
                editorTemplate: "TextField",
                displayName: "Email Id",
                defaultValue: "Email__c",
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
            },
            {
                name: fields.orgId,
                editorTemplate: "TextField",
                displayName: "Org Id",
                defaultValue: "00DWA000003csdZ",
                fieldType: "General",
                isRequired: true,
                sortOrder: 2,
            },
            {
                name: fields.alternateEmailId,
                editorTemplate: "TextField",
                displayName: "Alternate Email Id",
                defaultValue: "alternate-email",
                fieldType: "General",
                isRequired: true,
                sortOrder: 3,
            },
            {
                name: fields.caseDescriptionId,
                editorTemplate: "TextField",
                displayName: "Case Description Id",
                defaultValue: "description",
                fieldType: "General",
                isRequired: true,
                sortOrder: 4,
            },
            {
                name: fields.customerNameId,
                editorTemplate: "TextField",
                displayName: "Customer Name Id",
                defaultValue: "00N8M000000uWet",
                fieldType: "General",
                isRequired: true,
                sortOrder: 5,
            },
            {
                name: fields.customerNumberId,
                editorTemplate: "TextField",
                displayName: "Customer Number Id",
                defaultValue: "00N8M000000uWfI",
                fieldType: "General",
                isRequired: true,
                sortOrder: 6,
            },
            {
                name: fields.customerPartNumberId,
                editorTemplate: "TextField",
                displayName: "Customer Part Number Id",
                defaultValue: "00N8M000000uQlt",
                fieldType: "General",
                isRequired: true,
                sortOrder: 7,
            },
            {
                name: fields.danaPartNumberId,
                editorTemplate: "TextField",
                displayName: "Dana Part Number Id",
                defaultValue: "00N0H00000JCoTL",
                fieldType: "General",
                isRequired: true,
                sortOrder: 8,
            },
            {
                name: fields.plantCodeId,
                editorTemplate: "TextField",
                displayName: "Plant Code Id",
                defaultValue: "plantCode",
                fieldType: "General",
                isRequired: true,
                sortOrder: 9,
            },
            {
                name: fields.poNumberId,
                editorTemplate: "TextField",
                displayName: "PO Number Id",
                defaultValue: "00N0H00000JCoTU",
                fieldType: "General",
                isRequired: true,
                sortOrder: 10,
            },
            {
                name: fields.returnUrl,
                editorTemplate: "TextField",
                displayName: "Return Url",
                defaultValue:
                    "https://uzixes02sandboxaz.commerce.insitesandbox.com/customer-operations-case-widget?submit=success",
                fieldType: "General",
                isRequired: true,
                sortOrder: 11,
            },
            {
                name: fields.topicId,
                editorTemplate: "TextField",
                displayName: "Topic Id",
                defaultValue: "00N8M000000uQlj",
                fieldType: "General",
                isRequired: true,
                sortOrder: 12,
            },
        ],
    },
};
export default widgetModule;
